import { ExclamationTriangleIcon } from "@heroicons/react/24/outline"

interface Props {
  message: string | React.ReactNode
}

export const ErrorMessage = ({ message }: Props) => {
  return (
    <div className="mt-4 flex w-full items-center gap-x-2 border-l-2 border-red-500 bg-red-50 py-2.5 pr-4 pl-3 font-medium text-red-600">
      <ExclamationTriangleIcon className="h-5 w-5" aria-hidden="true" /> Error: {message}
    </div>
  )
}
